import React from "react";
import { Accordion, AccordionItem } from "Components/Accordion";
import WayPoints from "Components/Waypoints";

interface Props {
  suggestedTrails: any;
}

const ADATrails = (props: Props) => {
  const { suggestedTrails } = props;

  const trailStopMap = {};
  const trailsSortedByOrder = suggestedTrails.sort(
    (a: any, b: any) => a.order - b.order
  );
  trailsSortedByOrder.forEach((trail: any) => {
    trailStopMap[trail.name] = [];
    trail.Stops.forEach((stop: any) => {
      trailStopMap[trail.name].push(stop.title);
    });
  });

  return (
    <Accordion>
      {Object.keys(trailStopMap).map((trailName: any) => {
        // only want to display Trails that have associated destinations
        if (trailStopMap[trailName].length > 0) {
          const trailAccordionId = trailName.replace(/ /g, "-");
          return (
            <AccordionItem id={trailAccordionId} title={trailName}>
              <WayPoints steps={trailStopMap[trailName]} showTitle={false} />
            </AccordionItem>
          );
        }
        return null;
      })}
    </Accordion>
  );
};

export default ADATrails;

//  <ul>
//       <li>Stoney Brook Museum</li>
//       <li>Arts Center</li>
//       <li>Sociology Building</li>
//     </ul>

//   <AccordionItem id="trails-2" title="Athletics">

//   </AccordionItem>
